import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import {
  OrderFragment,
  useSchoolGroupSubscriptionQuery
} from "@pathwright/graphql-client/src/generated"
import { getPathname } from "../home/people/People"
import { getRelativeUrl } from "../utils/urls"
import { RenderActionButton } from "./OrderConfirmationContainer"
import OrderProcessing, { OrderProcessingLoading } from "./OrderProcessing"
import { isInFlowOrderConversion } from "./utils/in-flow-conversion"

function GroupSubscriptionOrderConfirmationContent({
  order,
  renderActionButton
}: {
  order: OrderFragment & { fulfilled_object_id: number }
  renderActionButton?: RenderActionButton
}) {
  const { t } = useTranslate()
  const redirectTo = order.order_data?.redirect_to
  const groupSubscriptionId = order.fulfilled_object_id
  const groupSubscriptionQuery = useSchoolGroupSubscriptionQuery({
    skip: !groupSubscriptionId,
    variables: {
      id: groupSubscriptionId
    }
  })
  const groupSubscription = groupSubscriptionQuery.data?.schoolGroupSubscription
  const stripeProduct = groupSubscription?.price?.product

  const isMultiSeatGroupSubscription =
    (groupSubscription?.subscription?.quantity || 0) > 1

  if (!groupSubscription || !stripeProduct) {
    return <OrderProcessingLoading />
  }

  let primaryAction: { children: string; to: string } | React.ReactNode =
    redirectTo
      ? {
          children: t("Continue"),
          to: getRelativeUrl(redirectTo)
        }
      : isMultiSeatGroupSubscription
      ? {
          children: t("Get Started"),
          to: getPathname({
            areaIndex: 1, // corresponds to "groups"
            nodeKey: `group:${groupSubscription.community_group!.id}`
          })
        }
      : {
          children: t("Get Started"),
          to: "/home/"
        }

  if (renderActionButton && isInFlowOrderConversion(order)) {
    primaryAction = renderActionButton(primaryAction)
  }

  return (
    <BlankSlate
      icon="check"
      heading={"Subscription Complete"}
      body={`Your subscription to ${stripeProduct.name} is complete. We've emailed you a receipt.`}
      primaryAction={primaryAction}
    />
  )
}

export function GroupSubscriptionOrderConfirmation({
  orderId,
  renderActionButton
}: {
  orderId: number
  renderActionButton?: RenderActionButton
}) {
  return (
    <OrderProcessing orderId={orderId}>
      {({ order }) => (
        <GroupSubscriptionOrderConfirmationContent
          order={order}
          renderActionButton={renderActionButton}
        />
      )}
    </OrderProcessing>
  )
}

export default function GroupSubscriptionOrderConfirmationCard({
  card,
  orderId,
  renderActionButton
}: {
  card: any
  orderId: number
  renderActionButton?: RenderActionButton
}) {
  return (
    <Card card={card} navless>
      <GroupSubscriptionOrderConfirmation
        orderId={orderId}
        renderActionButton={renderActionButton}
      />
    </Card>
  )
}
